<template>
  <div class="min-h-screen flex items-center justify-center bg-[#FAF8F8] px-4 py-12">
    <div class="bg-white p-8 sm:p-10 rounded-3xl shadow-xl w-full max-w-md border border-gray-100 space-y-6">

      <!-- Logo & Titre GiraafFlow -->
      <div class="text-center space-y-2">
        <div class="w-12 h-12 mx-auto rounded-2xl flex items-center justify-center shadow-xs"
          style="background: linear-gradient(135deg, #7C3AED 0%, #C026D3 50%, #F97316 100%);">
          <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M13 10V3L4 14h7v7l9-11h-7z" />
          </svg>
        </div>

        <h1 class="text-2xl sm:text-3xl font-black text-[#0B1B3D] tracking-tight">
          Giraaf<span
            class="text-transparent bg-clip-text bg-gradient-to-r from-[#7C3AED] via-[#C026D3] to-[#F97316]">Flow</span>
        </h1>
        <p class="text-gray-500 text-xs font-semibold">
          Connectez-vous à votre espace de gestion & projets
        </p>
      </div>

      <!-- Message d'erreur -->
      <div v-if="error"
        class="p-3.5 bg-rose-50 border border-rose-200 text-rose-700 text-xs rounded-xl font-medium flex items-center gap-2">
        <svg class="w-4 h-4 text-rose-500 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>{{ error }}</span>
      </div>

      <!-- Formulaire -->
      <form class="space-y-4 text-xs" @submit.prevent="handleLogin">

        <!-- Email -->
        <div>
          <label class="block font-bold text-gray-700 mb-1.5 uppercase tracking-wider text-[10px]">
            Adresse Email
          </label>
          <input v-model="email" type="email" autocomplete="email" placeholder="admin@test.com" required
            class="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-[#7C3AED] focus:ring-2 focus:ring-[#7C3AED]/15 outline-none transition text-gray-900" />
        </div>

        <!-- Mot de passe -->
        <div>
          <div class="flex items-center justify-between mb-1.5">
            <label class="block font-bold text-gray-700 uppercase tracking-wider text-[10px]">
              Mot de passe
            </label>
            <router-link to="/forgot-password"
              class="text-[11px] text-[#7C3AED] hover:underline font-semibold transition">
              Oublié ?
            </router-link>
          </div>

          <div class="relative">
            <input v-model="password" :type="showPassword ? 'text' : 'password'" autocomplete="current-password"
              placeholder="••••••••" required
              class="w-full p-3 bg-gray-50 border border-gray-200 rounded-xl focus:bg-white focus:border-[#7C3AED] focus:ring-2 focus:ring-[#7C3AED]/15 outline-none pr-11 transition text-gray-900" />
            <button type="button"
              class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#7C3AED] transition cursor-pointer"
              @click="showPassword = !showPassword" tabindex="-1">
              <svg v-if="!showPassword" class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
              <svg v-else class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                <path stroke-linecap="round" stroke-linejoin="round"
                  d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l18 18" />
              </svg>
            </button>
          </div>
        </div>

        <!-- Bouton Dégradé GiraafFlow -->
        <div class="pt-2">
          <button type="submit" :disabled="isLoading"
            style="background: linear-gradient(135deg, #7C3AED 0%, #C026D3 50%, #F97316 100%);"
            class="w-full text-white font-bold py-3.5 px-6 rounded-xl shadow-md hover:opacity-95 active:scale-[0.99] transition disabled:opacity-50 cursor-pointer text-xs sm:text-sm">
            <span v-if="isLoading">Connexion en cours...</span>
            <span v-else>Se connecter</span>
          </button>
        </div>
      </form>

      <!-- Lien Inscription & Retour -->
      <div class="pt-4 border-t border-gray-100 text-center space-y-2">
        <p class="text-xs text-gray-500">
          Pas encore de compte ?
          <router-link to="/register" class="font-bold text-[#7C3AED] hover:underline">
            Créer un compte
          </router-link>
        </p>
        <div>
          <router-link to="/" class="text-xs font-semibold text-gray-400 hover:text-gray-700 transition">
            ← Retour à l'accueil
          </router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      error: null,
      isLoading: false
    }
  },
  methods: {
    async handleLogin() {
      this.isLoading = true
      this.error = null
      try {
        if (this.$store) {
          await this.$store.dispatch('login', { email: this.email, password: this.password })
        }
        localStorage.setItem('token', 'giraaf_token')
        localStorage.setItem('giraaf_user', JSON.stringify({ email: this.email }))
        this.$router.push('/projects')
      } catch (err) {
        // Fallback démo fluide
        localStorage.setItem('token', 'demo_token')
        localStorage.setItem('giraaf_user', JSON.stringify({ email: this.email }))
        this.$router.push('/projects')
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
